<p>
  Комуникацията между купувачи и продавачи е ключова част от успешната сделка. В платформата имате няколко възможности
  да се свържете с продавача, в зависимост от етапа на обявата и текущото ви взаимодействие.
</p>
<h6 class="mt-3">1. Преди да направите покупка</h6>
<p>
  Ако имате въпрос относно даден артикул, може да използвате <strong>публичните коментари</strong>, които се намират
  в долната част на всяка обява. Чрез тях може да поискате допълнителна информация, уточнение за състояние,
  доставка или други детайли.
</p>
<p>
  Коментарите са <strong>видими за всички</strong>, включително други потенциални купувачи.
</p>
<h6 class="mt-3">2. След потвърдена покупка или спечелен търг</h6>
<p class="m-0">
  След като направите покупка или спечелите аукцион, платформата автоматично създава <strong>личен чат</strong> между
  вас и продавача. Това ви позволява да уточните всички аспекти на сделката.
</p>
<ul>
  <li>На страницата на обявата ще се появи бутон <strong>„Съобщение до продавача“</strong>.</li>
  <li>След изпращане на първото съобщение, разговорът ще бъде достъпен и в секцията <strong>„Съобщения“</strong> във
    вашия профил.
  </li>
  <li>В чата може да обсъдите: адрес за доставка, начин на плащане, срок за получаване и всякакви допълнителни
    уточнения.
  </li>
</ul>
<h6 class="mt-3">3. След прието ценово предложение</h6>
<p>
  Ако сте изпратили ценово предложение и то е прието от продавача, също ще бъде създаден <strong>личен чат</strong>,
  където да договорите детайлите по сделката.
</p>
<div class="alert alert-primary m-0">
  <strong>Съвет:</strong> Поддържайте учтива, ясна и делова комуникация. Всички съобщения се съхраняват в платформата и
  при нужда могат да бъдат използвани като доказателство при възникнал спор.
</div>
